import Swiper from '../vendors/swiper.min';

export default function galleryThumbs () {
    const mainGallery = $('.main-gallery');
    const prevBtn = $('.thumbs-button-prev');
    const nextBtn = $('.thumbs-button-next');

    if (mainGallery.length) {
        const thumbs = new Swiper('.thumbs', {
            spaceBetween: 0,
            slidesPerView: 9,
            freeMode: true,
            autoHeight: true,
            roundLengths: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    slidesPerView: 7
                },
                768: {
                    slidesPerView: 6
                },
                640: {
                    slidesPerView: 5
                },
                480: {
                    slidesPerView: 4
                },
                320: {
                    slidesPerView: 3
                }
            }
        });

        const gallery = new Swiper('.main-gallery', {
            spaceBetween: 0,
            roundLengths: true,
            autoHeight: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: thumbs
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            }
        });

        const counter = $('[data-gallery-counter]');

        // Output gallery images counter
        if (counter.length) {
            counter.text(returnCounter(gallery));

            gallery.on('slideChange', () => {
                counter.text(returnCounter(gallery));
            });
        }
    }

    function returnCounter (el) {
        return getCurrentIndex(el) +  '/'  + slidesCount(el);
    }

    function getCurrentIndex (el) {
        return el.realIndex + 1;
    }

    function slidesCount (el) {
        return el.slides.length;
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/inline-galery.js